module.exports = __webpack_public_path__ + "static/media/remote4.75c5f995.webp";